const VEHICLE_USAGE = [
    { value: "WorkInstrument", label: "Instrumento de Trabalho" },
    { value: "NecessaryDisplacement", label: "Deslocamento Necessário" },
];

export default VEHICLE_USAGE